import { ExportTypeEnum } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { CodeBookExtended, EditCodeBookRequest } from "../../models/CodeBook";

const languageUrlPrefix: string = "languages";

export const getLanguages = async () => {
  let result = await api.get(
    `${languageUrlPrefix}/detail`
  ) as CodeBookExtended[];
  setDatesLanguages(result);
  return result;
}

export const getLanguageById = async (id: number) => {
  let result = await api.get(
      `${languageUrlPrefix}/${id}`
  ) as CodeBookExtended;
  setDatesLanguage(result);
  return result
}

export const createLanguage = async (request: EditCodeBookRequest) => {
  return api.post(
      `${languageUrlPrefix}`,
      request
  ) as Promise<number>
}

export const editLanguage = async (id: number, request: EditCodeBookRequest) => {
  return api.put(
      `${languageUrlPrefix}/${id}`,
      request
  ) as Promise<void>
}

export const deleteLanguage = async (id: number) => {
  return api.delete(
      `${languageUrlPrefix}/${id}`
  ) as Promise<void>
}

export const exportLanguages = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${languageUrlPrefix}/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}

const setDatesLanguages = (items: CodeBookExtended[]) => {
  for (let item of items) {
    setDatesLanguage(item);
  }
}

const setDatesLanguage = (item: CodeBookExtended) => {
  if (item.dateTo) {
    item.dateTo = new Date(item.dateTo);
  }
}